<template>
    <div>
        <div class="row mt-3">
            <div class="col-sm-12 col-md-4 mb-2">
                <div class="dataTables_filter">
                    <label class="d-flex mb-0">
                        <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="search" @keypress.enter="filterStaffRoster">
                        <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterStaffRoster">
                            <i class="fas fa-search"></i>
                        </button>
                    </label>
                </div>
            </div>
            <div class="col-sm-12 col-md-4 mb-2"> 
                <div class="form-group d-flex">
                    <div class="input-group-prepend w-100">
                        <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                            <i class="fas fa-store"></i>
                        </label>
                        <multiselect  v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                            <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-4 mb-2"> 
                <div class="form-group d-flex">
                    <div class="input-group-prepend w-100">
                        <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                            <i class="fas fa-user"></i>
                        </label>
                        <multiselect  v-model="selectedStaff" label="name" track-by="staffID" :options="staffList" :searchable="false" :show-labels="false" openDirection="below" @select="filterByStaff">
                            <template slot="option" slot-scope="{ option }">{{option.name}}</template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2"> 
                <div class="form-group d-flex">
                    <div class="input-group-prepend w-100">
                        <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                            <i class="fas fa-tags"></i>
                        </label>
                        <multiselect  v-model="selectedBreakType" label="DfBreakTypeTitle" track-by="DfBreakTypeID" :options="breakType" :searchable="false" :show-labels="false" openDirection="below" @select="filterByBreakType">
                            <template slot="option" slot-scope="{ option }">{{option.DfBreakTypeTitle}}</template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2"> 
                <div class="form-group d-flex">
                    <div class="input-group-prepend w-100">
                        <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                            <i class="fas fa-tag"></i>
                        </label>
                        <multiselect  v-model="selectedStatus" label="text" track-by="id" :options="status" :searchable="false" :show-labels="false" openDirection="below" @select="filterByStatus">
                            <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                        </multiselect>
                    </div>
                </div>
            </div>
        </div>
        <div class="border-top pt-5 mt-3 text-center">
            <div class="d-flex">
                <a class="btn btn-outline-light fs-xl d-flex align-items-center" @click="setDate('prev')">
                    <i class="fas fa-chevron-left"></i>
                </a>
                <date-range-picker class="d-block w-100"
                    ref="picker"
                    v-model="selectedDate"
                    :opens="'center'"
                    :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                    :autoApply="true"
                    :showDropdowns="true" 
                    :always-show-calendars="true"
                    :single-date-picker="true"
                    :ranges="false"
                    @showCustomRange="showCustomRangeCalendars=false"
                    @update="filterByDate">
                    <template v-slot:input="picker">
                        <i class="text-primary fas fa-calendar-alt mr-2"></i>
                        {{setDateRange(picker.startDate, true)}} - {{setDateRange(picker.endDate, false)}} 
                    </template>
                </date-range-picker>
                 <a class="btn btn-outline-light fs-xl d-flex align-items-center" @click="setDate('next')">
                    <i class="fas fa-chevron-right"></i>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
export default {
    name: "staffRosterFilter",
    components:{
        DateRangePicker
    },
    data(){
        let startDate = moment().startOf('isoWeek');
        let endDate = moment().endOf('isoWeek');
        return{
            search: "",
            selectedDate:{startDate, endDate},
            selectedDateRange: {startDate, endDate},
            outlet: [], selectedOutlet: {},
            staffList: [],
            selectedStaff: {
                staffID: 'all', 
                name: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')})
            },
            breakType: [], selectedBreakType: {
                DfBreakTypeID: 'all', 
                DfBreakTypeTitle: this.$i18n.t('label.all', {'item': this.$i18n.t('table.header.type')})
            },
            selectedStatus: {
                id: "all",
                text: this.$i18n.t('label.all', {'item': this.$i18n.t('outlet_setting.roster.status')})
            }
        }
    },
    computed:{
        status(){
            return [
                {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('outlet_setting.roster.status')})},
                {id: "approved", text: this.$i18n.t('outlet_setting.roster.approved')},
                {id: "pending", text: this.$i18n.t('outlet_setting.roster.pending')},
                {id: "rejected", text: this.$i18n.t('outlet_setting.roster.rejected')},
            ]
        },
    },
    methods:{
        setDate(e){
            var date = moment(this.selectedDate.startDate)
            var formatDate = e == 'prev' ? date.subtract(7,'d') : date.add(7,'d')
            var startDate = moment(formatDate).startOf('isoWeek')
            var endDate = moment(formatDate).endOf('isoWeek')
            this.selectedDate = {startDate, endDate}
            this.filterByDate(this.selectedDate)
        },
        setDateRange(date, isStart){
            var formatDate = isStart ?  moment(date).startOf('isoWeek') :  moment(date).endOf('isoWeek')
            formatDate = formatDate.format('ddd, DD/MM/YYYY')
            return formatDate
        }, 
        setStaffList(staff){
            this.staffList = []
            this.staffList.push({
                staffID: 'all', 
                name: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')})
            })
            this.staffList.push(...staff)
        },
        setBreakType(breakType){
            this.breakType = []
            this.breakType.push({
                DfBreakTypeID: 'all', 
                DfBreakTypeTitle: this.$i18n.t('label.all', {'item': this.$i18n.t('table.header.type')})
            })
            this.breakType.push(...breakType)
            this.selectedBreakType = this.breakType[0]   
        },
        filterByDate(date){
            var startDate = moment(date.startDate).startOf('isoWeek')
            var endDate = moment(date.endDate).endOf('isoWeek')
            this.selectedDateRange = {startDate, endDate}
            this.filterStaffRoster()
        },
        filterByOutlet(item){
            this.selectedOutlet = item
            this.filterStaffRoster()
        },
        filterByStaff(item){
            this.selectedStaff = item
            this.filterStaffRoster()
        },
        filterByStatus(item){
            this.selectedStatus = item
            this.filterStaffRoster()
        },
        filterByBreakType(item){
            this.selectedBreakType = item
            this.filterStaffRoster()
        },
        filterStaffRoster(){
            var filterObj = {
                search: this.search,
                selectedDateRange: this.selectedDateRange,
                outlet: this.selectedOutlet,
                staff: this.selectedStaff.staffID,
                status: this.selectedStatus.id,
                breakType: this.selectedBreakType.DfBreakTypeID
            }
            this.$emit('filterStaffRoster', filterObj)
        }
    },
    mounted(){
        let $vm = this
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
        $vm.selectedStatus = $vm.status[0]
        $vm.filterStaffRoster()
    }
}
</script>